import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
const PrincipalMessage = () => {
  useEffect(() => {
    document.title =
      "Our Principal - Sacread Heart Kharagpur";
  }, []);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log(data);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData = await getPrincipalMessage();
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const emptyData = [{ id: 1 }];
  return (
    <>
     <Header/>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link> 
          </li>

          <li> Principal</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Principal </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {data.length > 0
                ? data.map((item) => (
                    <div className="clearfix">
                      <LazyLoad
                        offset={10}
                        placeholder={
                          <img
                            src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/dummy.jpg"
                            alt="Loading..."
                            className="img-fluid"
                          />
                        }>
                        <img
                          src={`https://webapi.entab.info/api/image/${item.attachments}`}
                          alt=""
                          className="col-md-4 float-md-end  left-img img-fluid"
                        />
                      </LazyLoad>

                        
                          <div className="innermsg" dangerouslySetInnerHTML={{ __html: item.message }} />
                        
                      <div className="mesdeskimg">
                        <h3> {item.name}</h3>
                        <h5> {item.category}</h5>
                      </div>
                    </div>
                  ))
                : emptyData.map((item) => (
                    <div className="clearfix">
                      <img
                        src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/dummy.jpg"
                        className="col-md-4 float-md-end  left-img img-fluid"
                      />
 
                      <p><i>On the Launch of Our New School Website</i></p>
                      <p><b>Dear Parents, Students, Teachers, and Staff,
                      Greetings to each one of you!</b></p> 
                      <p> It is with great joy and pride that I announce the launch of our new official website for Sacred Heart School, Kharagpur. This platform marks a new beginning in how we connect, share, and grow together as a school community. It will serve as a dynamic source of information, providing timely updates on academic activities, events, achievements, and important announcements. </p>
                      <p>As we step into this digital phase, I would like to emphasize two core values that have always been the foundation of our institution — discipline and punctuality. These values are more than just rules; they are life principles that shape responsible, respectful, and successful individuals.  </p>
                      <p>In everything we do, let us be guided by our school motto  <b>— “Strength and Wisdom.”</b> </p>
                      <p>Let us draw strength from our unity, our perseverance, and our shared commitment to excellence. And let us seek wisdom in our decisions, our learning, and our daily conduct. </p>
                      <p>I call upon our dear students to uphold these values proudly, our teachers and staff to continue being exemplary role models, and our parents to walk alongside us as partners in this journey. </p>
                      <p>Together, may we continue to build a school environment that fosters not just academic achievement, but also character, integrity, and purpose. </p>
                      <p>Thank you for your unwavering support. Let us make this new beginning a reflection of all that Sacred Heart School stands for. </p>
                      
                      <div className="mesdeskimg">
                        
                        <h3>  Fr. Gregory Monteiro</h3> <h5> Principal </h5>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrincipalMessage;
